<template>
  <div class="flex min-w-0 flex-col gap-1">
    <h4 class="flex font-normal">
      <span>
        {{ label }}
      </span>
      <Information v-if="infoText">
        <template #modal>{{ infoText }}</template>
      </Information>
    </h4>
    <div class="min-w-0 font-semibold"><slot></slot></div>
  </div>
</template>

<script setup lang="ts">
import Information from './Information.vue';

defineProps<{
  label?: string;
  infoText?: string;
}>();
</script>
